import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';

import { CommunicationWidgetName, CommunicationWidgetOfferReservation } from '@pwp-common';

import { AuthService } from '../../../user/auth/auth.service';
import { CommunicationWidgetService } from '../communication-widget/communication-widget.service';

@Injectable({
  providedIn: 'root',
})
export class CommunicationWidgetOfferReservationService extends CommunicationWidgetService<CommunicationWidgetOfferReservation> {
  ///////////////////////////////////////////////////////////////////////
  // Constructor
  ///////////////////////////////////////////////////////////////////////

  constructor(db: AngularFirestore, authService: AuthService) {
    super(db, authService, CommunicationWidgetOfferReservation);
  }

  ///////////////////////////////////////////////////////////////////////
  // Abstract Methods
  ///////////////////////////////////////////////////////////////////////

  protected getType(): CommunicationWidgetName {
    return CommunicationWidgetName.offerReservation;
  }
}
